import { useState } from 'react';
import { EnquiryTypeClient, EnquiryTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useEnquiryTypeApi = () => {
    const apiClient = new EnquiryTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: EnquiryTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createEnquiryType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating EnquiryType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: EnquiryTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateEnquiryType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating EnquiryType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getEnquiryTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching EnquiryType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchEnquiryTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching EnquiryTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteEnquiryType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting EnquiryType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};